/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "history-4896e1e6--sprite",
  "use": "history-4896e1e6--sprite-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 38\" id=\"history-4896e1e6--sprite\">\n  <g fill=\"currentColor\">\n    <path d=\"M20.009 10a9.013 9.013 0 0 0-8.867 7.463l-.969-.969a.6922575.6922575 0 1 0-.979.979l2.015 2.015c.015.015.033.027.049.04s.035.031.055.045a.7.7 0 0 0 .081.044c.013.006.025.014.038.02a.689.689 0 0 0 .1.032l.027.008a.672.672 0 0 0 .276 0l.026-.008a.7.7 0 0 0 .1-.032c.013-.005.024-.013.037-.019a.641.641 0 0 0 .088-.045c.019-.013.035-.029.053-.043s.035-.026.051-.042l2.017-2.015a.6922575.6922575 0 1 0-.979-.979l-.591.591a7.615 7.615 0 1 1 .9 5.932.6923397.6923397 0 0 0-1.176.731A9 9 0 1 0 20.009 10Z\" />\n    <path d=\"M22.861 18.308h-2.16v-4.154a.692.692 0 0 0-.692-.692.692.692 0 0 0-.692.693v4.846a.692.692 0 0 0 .692.692h2.852a.6925.6925 0 0 0 0-1.385Z\" />\n  </g>\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
